import React, { useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import DOMPurify from 'dompurify';
import TextField from '@mui/material/TextField';
import ButtomCustom from '../../ButtonRound';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import TrueFalseQuestion from '../components/TrueFalseQuestion';
import { useSelector } from 'react-redux';
import AlertModal from '../components/AlertModal';
import TestTitle from '../TestTitle';
import parse from 'html-react-parser';
import { getPathCourseResource } from '../../../utils/electronFunctions';
import HttpClient from '../../../helpers/HttpClient'; 
import { ToastContainer } from 'react-toastify';
import OverlayLoader from '../../OverlayLoader';
import { showToast } from '../../../utils/toast';
import { getMysqlDate } from '../../../utils/generals';
import '../styles.scss';

const TrueFalseTest = ({ data, courseCode, onFinalize, onContinue }) => {
  const [open, setOpen] = useState(false);
  const [answers, setAnswers] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [openModalWelcome, setOpenModalWelcome] = useState(true);
  const [openModalEnd, setOpenModalEnd] = useState(false);
  const [currentTest, setTest] = useState(null);
  const [categories, setCategories] = useState([]);
  const categoryResponseArray = useRef([]);
  const [testSaved, setTestSaved] = useState(false);
  const [modalInitData, setModalInitData] = useState({
    title: '',
    content: '',
    buttonText: '',
  });
  const [modalEndData, setModalEndData] = useState({
    title: '',
    content: '',
    buttonText: '',
  });
  const authState = useSelector((state) => state.auth);
  const handleAnswerChange = (index, category, value) => {
    const newAnswers = [...answers];
    newAnswers[index] = {
      category: category,
      value: value,
    };
    console.log(newAnswers);
    setAnswers(newAnswers);
  };

  const imagePaths = async (html, stringImages, path) => {
    const images = stringImages ? stringImages.split(',') : null;
    let content = html;
    if (Array.isArray(images)) {
      for (let i = 0; i < images.length; i++) {
        let finalPath = '';
        if (images[i].indexOf('commons/') != -1) {
          finalPath = await getPathCourseResource(
            images[i].replace('commons', 'commons')
          );
        } else {
          finalPath = await getPathCourseResource(
            path + '/img/' + images[i]
          );
        }
        content = content.replace(images[i], finalPath);
      }
    }
    return content;
  };

  const loadTestData = async () => {
    setModalEndData({
      title: '',
      content: '',
      buttonText: '',
    });

    const userId = authState && authState.user ? authState.user.email : 'test';

    const request = await HttpClient().get(`/tests/truefalse/${userId}/${data.test_id}`);

    if (request.error) {
      showToast("No se pudo cargar información del test. Refresca la página e intenta nuevamente.", "error");
      return;
    }

    const test = request.data.test;
    let testData = null;
    console.log(test);
    if (test) {
      setTest(test);
      testData = test;
      if (testData.encabezado && testData.encabezado != '') {
        let htmlContent = testData.encabezado;
        const path = courseCode;
        if (testData.img_encabezado && testData.img_encabezado != '') {
          htmlContent = await imagePaths(
            htmlContent,
            testData.img_encabezado,
            path
          );
        }
        setModalInitData({
          content: htmlContent,
          buttonText:
            testData.texto_boton && testData.texto_boton != ''
              ? testData.texto_boton
              : 'Aceptar',
        });
      } else {
        setModalInitData({
          content: '',
          buttonText: '',
        });
      }
    } else {
      setModalInitData({
        content: '',
        buttonText: '',
      });
    }
    console.log(testData);
    if (testData) {

      const questions = request.data.questions;

      console.log(questions);

      const answersTest = request.data.answers;

      console.log(answersTest)
      

      if (questions) {
        
        setQuestions(questions);

        if (answersTest && answersTest.length > 0) {
          const answersTemp = [];
          for (let i = 0; i < questions.length; i++) {
            const r = answersTest.filter(
              (ele) => ele.id_pregunta == questions[i].id
            )[0];
            answersTemp.push({
              category: questions[i].category,
              value: r.valor,
            });
          }
          setAnswers(answersTemp);
        }else{
          setAnswers(
            new Array(questions.length).fill({
              category: '',
              value: null,
            })
          );
        }


        
        const categoryArray = [
          ...new Set(
            questions.map((ele, index) => {
              return ele.category;
            })
          ),
        ];
        setCategories(categoryArray);
      } else {
        setQuestions([]);
        setAnswers([]);
        setCategories([]);
      }
    }
  };

  const insertDataTest = async () => {

    const userId =
        authState && authState.user ? authState.user.email : 'test';
      const currentDate = getMysqlDate();
      const arrayValues = [];

      for (let i = 0; i < answers.length; i++) {
        arrayValues.push({
          userId: userId,
          cod_test: currentTest.cod_test,
          questionId: questions[i].id,
          answerValue: answers[i].value,
          currentDate: currentDate,
        });
      }

      const originId = data.id ? data.id : data.cod_leccion;
      const originType = data.id ? "SUBLESSON" : "LESSON";
    
    const request = await HttpClient().post(`/tests/truefalse/save/${userId}/${originId}/${currentTest.cod_test}/${originType}`, arrayValues)

    onFinalize(true);
    
  }

  const saveTest = async () => {
    const empty = answers.filter((ele) => ele.value == null).length;
    if (empty > 0) {
      showToast('Debes completar todo el test');
    } else {
      setOpen(true);
      const extro = answers.filter(
        (ele) =>
          (ele.value == '1' && ele.category == 'IE_EXTRO') ||
          (ele.value == '0' && ele.category == 'IE_INTRO')
      ).length;
      const percentage = Math.round((100 * extro) / answers.length);
      await insertDataTest();
      setTestSaved(true);

      setModalEndData({
        title: 'Introvertido o Extrovertido',
        content: `Tienes un mayor porcentaje de ${
          percentage >= 60 ? 'EXTROVERSIÓN' : 'INTROVERSIÓN'
        }  en un ${percentage >= 60 ? percentage : 100 - percentage}%`,
        buttonText: 'Aceptar',
      });
      setOpen(false);
      setOpenModalEnd(true);
    }
  };

  useEffect(() => {
    if (data) {
      setOpen(true);
      loadTestData();
      document.getElementsByClassName("main")[0].scrollTo({ top: 0, left: 0 });
      setOpen(false);
    }
  }, [data]);

  return (
    <Grid container columns={{ xs: 4, md: 12 }} spacing={2} key={data.test_id}>
      <OverlayLoader open={open} />
      {currentTest ? (
        <>
          <Grid item xs={12}>
            {data ? <TestTitle title={data.nombre} color={'white'} /> : null}
          </Grid>
          <Grid item xs={12}>
            <div className="tests-container">
              {questions.map((question, index) => {
                return (
                  <TrueFalseQuestion
                    question={question}
                    key={index}
                    defaultValue={answers[index] && answers[index].value > -1 ? answers[index].value: null}
                    scale={{
                      min: currentTest.rango_inicial,
                      max: currentTest.rango_final,
                    }}
                    onAnswerChange={(value) =>
                      handleAnswerChange(index, question.category, value)
                    }
                  />
                );
              })}
            </div>
          </Grid>
          <Grid item xs={12} className="lessons-button-container-center">
            {!testSaved ? (
              <ButtomCustom onClick={saveTest} variant="contained" rounded>
                Guardar
              </ButtomCustom>
            ) : (
              <ButtomCustom onClick={onContinue} variant="contained" rounded>
                Continuar
              </ButtomCustom>
            )}
          </Grid>
          <AlertModal
            open={openModalWelcome}
            title={''}
            content={parse(modalInitData.content)}
            buttonText={modalInitData.buttonText}
            onButtonClick={() => {
              setOpenModalWelcome(false);
            }}
          />
          <AlertModal
            open={openModalEnd}
            title={modalEndData.title}
            content={modalEndData.content}
            buttonText={modalEndData.buttonText}
            onButtonClick={() => {
              setOpenModalEnd(false);
            }}
          />
        </>
      ) : null}
      {/*<ToastContainer />*/}
    </Grid>
  );
};

export default TrueFalseTest;
